var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    style: {
      color: "#3b7cc9"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.293 3.293A1 1 0 0 1 10 3h4a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1v8a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3v-8a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h3V4a1 1 0 0 1 .293-.707ZM7 8h10V7H7v1Zm1 2v8a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-8H8Zm6 8a1 1 0 0 1-1-1v-5a1 1 0 1 1 2 0v5a1 1 0 0 1-1 1Zm-5-1a1 1 0 1 0 2 0v-5a1 1 0 1 0-2 0v5Z",
    clipRule: "evenodd"
  })));
};
export default SvgTrash;